import React from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";

const FooterSection = styled.footer`
  background: #151414;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 60px 15px 10px 15px;
`;

const CtaSection = styled.div`
  border-bottom: 1px solid #373636;
  padding-bottom: 30px;
`;

const Cta = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const SingleCta = styled.div`
  flex: 0 0 100%;
  margin-bottom: 20px;

  @media (min-width: 768px) {
    flex: 0 0 32%;
  }
`;

const CtaIcon = styled.i`
  color: #ff5e14;
  font-size: 30px;
  float: left;
  margin-top: 8px;
`;

const CtaText = styled.div`
  padding-left: 40px;
`;

const Heading = styled.h4`
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 5px;
`;

const Link = styled.a`
  color:rgb(230, 230, 230);
  text-decoration: none;
  transition: color 0.3s ease;

  &:hover {
    color: #ff5e14;
  }
`;

const ContentSection = styled.div`
  padding-top: 50px;
`;

const FooterLogo = styled.div`
  margin-bottom: 30px;

  img {
    max-width: 60%;
    height: auto;
  }
`;

const FooterText = styled.p`
  margin-bottom: 1px; /* Reduce margin to tighten space */
  font-size: 16.5px;
  color:rgb(255, 255, 255);
  line-height: 1.8;
`;

const Widget = styled.div`
  margin-bottom: 0px;

  h3 {
    color: #fff;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 30px;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      left: 0;
      bottom: -10px;
      height: 2px;
      width: 50px;
      background: #ff5e14;
    }
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  li {
    display: inline-block;
    width: 50%;
    margin-bottom: 12px;

    a {
      color: #878787;
      text-transform: capitalize;
      transition: color 0.3s ease;

      &:hover {
        color: #ff5e14;
      }
    }
  }
`;

const CopyRight = styled.div`
  background: #202020;
  padding: 25px 0;

  p {
    margin: 0;
    font-size: 14px;
    color: #878787;

    a {
      color: #ff5e14;
    }
  }
`;

const SocialMediaSection = styled.div`
  margin-top: 0px; /* Adjust to reduce the space above */
  p {
    margin-bottom: 10px; /* Tighten space between header and icons */
    color:rgb(255, 252, 252);
     font-size: 20px;
  }
  .social-icons {
    display: flex;
    gap: 15px; /* Space between icons */
  }
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterSection>
      <Container>
        <CtaSection>
          <Cta>
            <SingleCta>
              <CtaIcon className="fas fa-map-marker-alt" />
              <CtaText>
                <Heading>Find us</Heading>
                <Link
                  href="https://www.google.com/maps?q=4th+Floor,+R-5+Heights,+new+dp+road,+Vishal+Nagar,+Pune,+Pimpri-Chinchwad,+Maharashtra+412301"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Nextech PLM Solutions Pvt. Ltd., 4th Floor, R-5 Heights, New
                  DP Road, Vishal Nagar, Pune, Pimpri-Chinchwad, Maharashtra
                  412301
                </Link>
              </CtaText>
            </SingleCta>
            <SingleCta>
              <CtaIcon className="fas fa-phone" />
              <CtaText>
                <Heading>Call us</Heading>
                <Link href="tel:+917020633889">+91 9970166224</Link>
              </CtaText>
            </SingleCta>
            <SingleCta>
              <CtaIcon className="far fa-envelope-open" />
              <CtaText>
                <Heading>Mail us</Heading>
                <Link href="mailto:info@nextechplm.com">
                  info@nextechplm.com
                </Link>
              </CtaText>
            </SingleCta>
          </Cta>
        </CtaSection>
        <ContentSection>
          <div className="row">
            <div className="col-lg-4 mb-4">
              <Widget>
                <FooterLogo>
                  <a href="index.html">
                    <img
                      src="https://github.com/Dhananjaywarade/logo/blob/main/others/NEXTECHLOGO.jpg?raw=true"
                      alt="logo"
                    />
                  </a>
                </FooterLogo>
                <FooterText>
                  NexTech is a top PLM and Engineering solutions provider,
                  empowering global customers in digital transformation with
                  Teamcenter PLM as their core platform.
                </FooterText>
              </Widget>
            </div>
            <div className="col-lg-4 mb-4">
              <Widget>
                <h3>Useful Links</h3>
                <ul>
                  <li>
                    <NavLink to="/">Home</NavLink>
                  </li>
                  <li>
                    <NavLink to="/about">About us</NavLink>
                  </li>
                  <li>
                    <NavLink to="/career">Career</NavLink>
                  </li>
                  <li>
                    <NavLink to="/contact">Contact Us</NavLink>
                  </li>
                  <li>
                    <NavLink to="/blog">Blogs</NavLink>
                  </li>
                  <li>
                    <NavLink to="/teamcenter/mcad-integration">
                      MCAD integration
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/teamcenter/ecad-integration">
                      ECAD integration
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/teamcenter/cybersecurity">
                      Teamcenter cybersecurity
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/teamcenter/implementation">
                      Teamcenter Implementation
                    </NavLink>
                  </li>
                </ul>
              </Widget>
            </div>
            <div className="col-lg-4 mb-4">
              <Widget>
                <h3>Our Solution</h3>
                <ul>
                  <li>
                    <NavLink to="/mendix-apps-solutions">
                      Mendix Apps Solution
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/polarion-alm-solution">
                      Polarian ALM Solution
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/sharepoint-insight-pdm-implementation">
                      SharePoint
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/teamcenter/staff-augmentation-services">
                      Staff Augmentation
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/teamcenter/software-development-services">
                      Software Development
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/teamcenter/support-consulting-services">
                      Support and Consulting
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/teamcenter/plm-solutions-amc">
                      PLM Solutions AMC
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/teamcenter/redefining-plm-solution">
                      Redefining PLM Solutions
                    </NavLink>
                  </li>
                </ul>
              </Widget>
            </div>
          </div>

          {/* Social Media Section */}
          <SocialMediaSection>
            <p>Connect with us:</p>
            <div className="social-icons">
            <a
                href="https://www.linkedin.com/company/nextech-plm-solutions/"
                className="linkedin"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa-brands fa-linkedin"></i>
              </a>
              <a
                href="https://www.facebook.com/share/vNf8TQB9UWD12RVY/?mibextid=qi2Omg"
                className="facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa-brands fa-facebook-f"></i>
              </a>
              <a
                href="https://twitter.com/NextechPlm"
                className="twitter"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa-brands fa-x-twitter"></i>
              </a>
              <a
                href="https://www.instagram.com/nextech_plm_solutions?igsh=MTUwOWtvM3h2cHJrdw=="
                className="instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fa-brands fa-instagram"></i>
              </a>
             
            </div>
          </SocialMediaSection>
        </ContentSection>
      </Container>
      <CopyRight>
        <div>
          <p className="text-center">
            Copyright &copy; {currentYear}, All Rights Reserved
          </p>
        </div>
      </CopyRight>
    </FooterSection>
  );
};

export default Footer;
